<div class="list-data" [ngClass]="{'hidden': options?.length === 0}">
    <p-listbox emptyMessage=" " [options]="getSortedOptions()" [(ngModel)]="selectedValue" (onClick)="onContractSelection($event)">
        <ng-template let-data pTemplate="item">
            <div class="w-full flex-body">
                <span class="m-r-8">{{data | contractDisplay}}
                    <span class="default-text green" *ngIf = "data.isDefaultContract" >{{'DEFAULT' | translate}}</span>
                </span>
            </div>
        </ng-template>
    </p-listbox>
</div>
<label *ngIf="options && options.length === 0" class="no-data-msg">{{'vbeiNoContractsFoundError' |translate}}</label>
<label [ngClass]="{'hidden': (options && (options.length > 0 || options.length <= 0))}" class="no-data-msg loading-label">{{'vbeLoading' | translate}}</label>